import React from "react";

import { Form, Formik } from "formik";

import { Grid, IconButton } from "@mui/material";
import { ArrowBackIos } from "@mui/icons-material";

import { StyledGridContainer } from "../../../components/StyledLayout";
import { StyledCard } from "../../../components/StyledCard";

import { routesConfig } from "../../../config/routes";
import { useContextualNavigate } from "../../../hooks/ContextualNavigations";

import { validationSchemaUpdatePassword } from "./form/validationSchema";
import { initialValuesFormikUpdatePassword } from "./form/initialValues";

import SucessPasswordMessage from "./sheet/SuccessPasswordMessage";
import FirstAccessPassword from "./sheet/FirstAccessPassword";
import { useUpdatePasswordSubmit } from "./hook/useUpdatePasswordSubmit";

export const UpdatePasswordDefault: React.FC = () => {
  const navigate = useContextualNavigate();
  const { handleSubmit, successUpdatePassword, email } = useUpdatePasswordSubmit();

  const handleClickGoToBackHome = () => {
    navigate(`${routesConfig.LOGIN}`);
  };

  return (
    <StyledGridContainer className="UpdatePasswordDefault">
      <StyledCard>
        <Formik
          validateOnMount
          initialValues={{ ...initialValuesFormikUpdatePassword, email }}
          validationSchema={validationSchemaUpdatePassword}
          onSubmit={handleSubmit}
        >
          {(propsFormik) => (
            <Form>
              <Grid container>
                <Grid item>
                  <IconButton
                    onClick={handleClickGoToBackHome}
                    edge="end"
                    sx={{ display: "flex" }}
                  >
                    <ArrowBackIos sx={{ color: "primary.main", opacity: "1" }} />
                  </IconButton>
                </Grid>
                <Grid item>
                  {successUpdatePassword ? (
                    <SucessPasswordMessage onClick={handleClickGoToBackHome} isSubmitting={propsFormik.isSubmitting} />
                  ) : (
                    <FirstAccessPassword {...propsFormik} />
                  )}
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      </StyledCard>
    </StyledGridContainer>
  );
};

export default UpdatePasswordDefault;
